/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AbsencesComponent } from '@absences/absences/absences.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserListComponent } from '@app/user/user-list/user-list.component';
import { VehiclesComponent } from '@app/vehicles/vehicles/vehicles.component';
import { AppointmentDetailComponent } from '@appointments/appointment-detail/appointment-detail.component';
import { AuthGuard } from '@auth/guard/auth.guard';
import { SuperAdminGuard } from '@auth/guard/super-admin.guard';
import { WriteAccessGuard } from '@auth/guard/write-access.guard';
import { LoginComponent } from '@auth/login/login.component';
import { ConstructionSitesComponent } from '@construction-sites/construction-sites/construction-sites.component';
import { TourMonthOverviewComponent } from '@construction-sites/tour-month-overview/tour-month-overview.component';
import { CustomersComponent } from '@customers/customers/customers.component';
import { DepartmentsComponent } from '@departments/departments/departments.component';
import { DriversComponent } from '@drivers/drivers/drivers.component';
import { TourDetailComponent } from '@tours/tour-detail/tour-detail.component';
import { TourNotesListComponent } from '@tours/tour-notes-list/tour-notes-list.component';
import { ToursComponent } from '@tours/tours/tours.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: 'tours', component: ToursComponent },
      { path: 'tours/new', component: TourDetailComponent, canActivate: [WriteAccessGuard] },
      { path: 'tours/:tourId/edit', component: TourDetailComponent },
      { path: 'tours/:tourId/notes', component: TourNotesListComponent },
      { path: 'appointments/new', component: AppointmentDetailComponent, canActivate: [WriteAccessGuard] },
      { path: 'appointments/:appointmentId/edit', component: AppointmentDetailComponent },
      { path: 'vehicles', component: VehiclesComponent },
      { path: 'vehicles/:vehicleId', component: AbsencesComponent },
      { path: 'drivers', component: DriversComponent },
      { path: 'drivers/:driverId', component: AbsencesComponent },
      { path: 'departments', component: DepartmentsComponent, canActivate: [SuperAdminGuard] },
      { path: 'customers', component: CustomersComponent },
      { path: 'customers/:customerId/construction_sites', component: ConstructionSitesComponent },
      { path: 'customers/:customerId/construction_sites/:constructionSiteId/tours', component: TourMonthOverviewComponent },
      { path: 'customers/:customerId/construction_sites/:constructionSiteId/tours/:tourId/edit', component: TourDetailComponent },
      { path: 'users', component: UserListComponent },
      { path: '**', redirectTo: 'tours' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
